<template>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_portals" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Förmånsportaler</h2>

		</div>

		<div id="form_portals" class="panel-collapse collapse">

			<div class="panel-body">

				<h3>Denna punkt stäms av vid första "intervjusamtal" innan man går in på själva intervjun</h3>
				<p class="comment subline">Gäller endast mottagningsmassörer.</p>

				<div class="form-horizontal">

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_is_on_benify"
							layout="selectMenu"
							title="Finns själv med på Benify">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_is_on_epassi"
							layout="selectMenu"
							title="Finns själv med på ePassi">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_is_on_soderberg"
							layout="selectMenu"
							title="Finns själv med på Söderberg & Partner">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_is_on_wellnet"
							layout="selectMenu"
							title="Finns själv med på Wellnet">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_is_on_benefits"
							layout="selectMenu"
							title="Finns själv med på Benefits">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_is_on_edenred"
							layout="selectMenu"
							title="Finns själv med på Edenred">
					</row-meta>

				</div>

				<h3>Interna anteckningar gällande portaler för denna mottagning</h3>

				<div class="form-horizontal">

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_benify_use"
							layout="selectMenu"
							title="Skall läggas upp på Benify">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="checkbox_benify_updated"
							layout="checkBox"
							title="Upplagd på Benify">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_epassi_use"
							layout="selectMenu"
							title="Skall läggas upp på ePassi">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="checkbox_epassi_updated"
							layout="checkBox"
							title="Upplagd på ePassi">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_soderberg_use"
							layout="selectMenu"
							title="Skall läggas upp på Söderberg & Partner">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="checkbox_soderberg_updated"
							layout="checkBox"
							title="Upplagd på Söderberg & Partner">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_wellnet_use"
							layout="selectMenu"
							title="Skall läggas upp på Wellnet">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="checkbox_wellnet_updated"
							layout="checkBox"
							title="Upplagd på Wellnet">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_benefits_use"
							layout="selectMenu"
							title="Skall läggas upp på Benefits">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="checkbox_benefits_updated"
							layout="checkBox"
							title="Upplagd på Benefits">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							:extra-data="{'Inget val': 1, 'Ja': 2, 'Nej': 3}"
							:showComment="true"
							type="select_edenred_use"
							layout="selectMenu"
							title="Skall läggas upp på Edenred">
					</row-meta>

					<row-meta
							:clinic-id="clinic.id"
							:row-meta="meta"
							type="checkbox_edenred_updated"
							layout="checkBox"
							title="Upplagd på Edenred">
					</row-meta>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

import mixin from './mixin'

export default {

    	mixins: [mixin],

	    data () {
      		return {

      		}
	    }

}

</script>
